import { Action } from '@ngrx/store';
import {
    PREFERENCE_COMPANY_SET,
    PREFERENCE_CONNECTIONS_SET,
    PREFERENCE_FETCH,
    PREFERENCE_LOCATION_SET,
    PREFERENCE_MERGE,
    PREFERENCE_MULTI_LOCATION_SET,
    PREFERENCE_SAVE,
    PREFERENCE_SET,
    PREFERENCE_SORT_GROUP_SET,
    PREFERENCE_DELIVERIES_SET,
    PREFERENCE_UNIT_MEASUREMENT_SET,
    PREFERENCE_IHDSITES_SET,
    PREFERENCE_LIVEORDERS_SET,
    PREFERENCE_REPORTS_SET
} from '../action-types';
import { UserPreference } from '@core/models/preference/user-preference';
import { CompanyPreference } from '@core/models/preference/company-preference';
import { Company } from '@core/models/common/company';
import { DeliveryListPreference } from '@core/models/preference/delivery-list.preference';
import { ConnectionListPreference } from '@core/models/preference/connection-list-preference';
import { PreferenceSortType } from '@core/models/preference/preference-sort-type';
import { PreferenceGroupType } from '@core/models/preference/preference-group-type';
import { Location } from '@core/models/location/location';
import { LiveOrdersListPreference } from '@core/models/preference/live-orders-list.preference';
import { ReportsPreference } from '@core/models/preference/reports.preference';

export class SetPreferenceAction implements Action {
    readonly type = PREFERENCE_SET;

    constructor(
        public payload: {
            user?: {
                [id: string]: UserPreference;
            };
            company?: {
                [id: string]: CompanyPreference;
            };
        }
    ) {}
}

export class MergePreferenceAction implements Action {
    readonly type = PREFERENCE_MERGE;

    constructor(
        public payload: {
            user?: {
                [id: string]: UserPreference;
            };
            company?: {
                [id: string]: CompanyPreference;
            };
        }
    ) {}
}

export class SetLocationPreferenceAction implements Action {
    readonly type = PREFERENCE_LOCATION_SET;

    constructor(
        public payload: {
            userId: string;
            location: Location;
            scheduleId?: string;
            skipExternalUpdate?: boolean;
        }
    ) {}
}

export class SetCompanyPreferenceAction implements Action {
    readonly type = PREFERENCE_COMPANY_SET;

    constructor(
        public payload: {
            userId: string;
            company: Company;
        }
    ) {}
}

export class SetUnitMeasurementPreferenceAction implements Action {
    readonly type = PREFERENCE_UNIT_MEASUREMENT_SET;

    constructor(
        public payload: {
            userId: string;
            companyId: string;
            unitMeasurement: string;
        }
    ) {}
}

export class SetMultiLocationPreferenceAction implements Action {
    readonly type = PREFERENCE_MULTI_LOCATION_SET;

    constructor(
        public payload: {
            userId: string;
            companyId: string;
            isMultiLocation: boolean;
        }
    ) {}
}

export class SetDeliveryListPreferenceAction implements Action {
    readonly type = PREFERENCE_DELIVERIES_SET;

    constructor(
        public payload: {
            userId: string;
            companyId: string;
            orderList: DeliveryListPreference;
        }
    ) {}
}

export class SetLiveOrdersPreferenceAction implements Action {
    readonly type = PREFERENCE_LIVEORDERS_SET;

    constructor(
        public payload: {
            userId: string;
            companyId: string;
            liveOrdersList: LiveOrdersListPreference;
        }
    ) {}
}

export class SetReportsPreferenceAction implements Action {
    readonly type = PREFERENCE_REPORTS_SET;

    constructor(
        public payload: {
            userId: string;
            companyId: string;
            reports: ReportsPreference;
        }
    ) {}
}

export class SetConnectionsPreferenceAction implements Action {
    readonly type = PREFERENCE_CONNECTIONS_SET;

    constructor(
        public payload: {
            userId: string;
            companyId: string;
            connectionList: ConnectionListPreference;
        }
    ) {}
}


export class SetSortGroupPreferenceAction implements Action {
    readonly type = PREFERENCE_SORT_GROUP_SET;

    constructor(
        public payload: {
            userId: string;
            sort: PreferenceSortType;
            group: PreferenceGroupType;
        }
    ) {}
}

export class SavePreferenceAction implements Action {
    readonly type = PREFERENCE_SAVE;

    constructor(
        public payload?: {
            user?: UserPreference;
            company?: any;
        }
    ) {}
}

export class FetchPreferenceAction implements Action {
    readonly type = PREFERENCE_FETCH;

    constructor(
        public payload?: {
            user?: UserPreference;
            company?: any;
        }
    ) {}
}

export class SetIHDSitesPreferenceAction implements Action {
    readonly type = PREFERENCE_IHDSITES_SET;

    constructor(public payload: {
        userId: string,
        ihdSites: any[]
    }) {}
}
